import http from '../const/http-common'

const getHeaders = () => ({
  Authorization: `Bearer ${localStorage.getItem('token')}`,
  'ngrok-skip-browser-warning': true,
  'Content-Type': 'application/json',
})

const listCompetitors = () =>
  http.get('/v1/competitor/list', { headers: getHeaders() })

const addCompetitor = (ticker) =>
  http.post('/v1/competitor/add', { ticker }, { headers: getHeaders() })

const removeCompetitor = (id) =>
  http.delete(`/v1/competitor/${id}`, { headers: getHeaders() })

const syncCompetitor = (id) =>
  http.post(`/v1/competitor/${id}/sync`, {}, { headers: getHeaders() })

const financialComparison = (payload) =>
  http.post('/v1/user/financial-comparison', payload, { headers: getHeaders() })

const competitorService = {
  listCompetitors,
  addCompetitor,
  removeCompetitor,
  syncCompetitor,
  financialComparison,
}

export default competitorService
